import { Headphones, Pause, Square } from "lucide-react";
import { useSpeech } from "./useSpeech";

export const ListenControls = ({ text }) => {
  const { supported, status, play, pause, stop } = useSpeech(text);
  if (!supported) return null;
  return (
    <div className="flex items-center gap-1" data-testid="listen-controls">
      <button
        onClick={status === "playing" ? pause : play}
        data-testid="listen-toggle-button"
        className="flex items-center gap-2 border border-[#2C402E] text-[#2C402E] hover:bg-[#2C402E] hover:text-[#FAF9F6] px-3 py-1.5 text-xs font-body tracking-wide transition-colors"
      >
        {status === "playing" ? <Pause size={14} /> : <Headphones size={14} />}
        {status === "playing" ? "Pause" : status === "paused" ? "Reprendre" : "Écouter"}
      </button>
      {status !== "idle" && (
        <button onClick={stop} data-testid="listen-stop-button" aria-label="Arrêter la lecture" className="border border-[#D1CFC7] text-[#4A4A4A] p-2 transition-colors hover:border-[#9E4735] hover:text-[#9E4735]">
          <Square size={12} />
        </button>
      )}
    </div>
  );
};
